import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import { IS_ON_IFRAME, PortalProvider } from '@stlm/common-ui/lib'
import { AppHeader } from './components/AppHeader/AppHeader'
import css from './App.module.scss'
import { GET_VERSIONS } from './constants/versions'
import { AuthWrapper } from './components/AuathWrapper/AuthWrapper'

export const App: FC = () => (
  <PortalProvider scope="@CHILD SOCIALMAP">
    <AuthWrapper>
      <div className={css.app}>
        {!IS_ON_IFRAME && <AppHeader />}
        <main>
          <Outlet />
        </main>
        {!IS_ON_IFRAME && (
          <footer
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: '5px',
            }}
          >
            Build Version: {GET_VERSIONS.GET_VERSIONS}
          </footer>
        )}
      </div>
    </AuthWrapper>
  </PortalProvider>
)
